(ns net.kestec.mhda-pilgrimage.public.application.widgets.welcome-action-block
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Card" :default Card]
    ["@mui/material/CardContent" :default CardContent]
    ["@mui/material/CardActions" :default CardActions]
    ["@mui/material/Button" :default Button]
    ["@mui/material/CircularProgress" :default CircularProgress]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.route :as route]
    [re-frame.core :as rf]
    [reagent.core :as r]
    ))


(rf/reg-event-fx
  ::set-step
  (fn [{db :db} [_ t]]
    {:dispatch [::route/push
                (:name (:data (::route/route db)))
                :path-params (:path-params (::route/route db))
                :query-params (assoc (:query-params (::route/route db))
                                :step t)]}))


(rf/reg-sub
  ::get-step
  (fn [{:as db {:keys [query-params]} ::route/route} _]
    (or (:step query-params) "")))





(defn start-button []
  (if @(rf/subscribe [::db/get ::db/me :is-valid])
    [:> Button {:variant "outlined"
                :color   "primary"
                :onClick #(rf/dispatch [::route/push ::route/dashboard])
                } "Zur Anmeldungs-Übersicht"]

    [:> Button {:variant "outlined"
                :sx      {:marginRight "20px"}
                :color   "primary"
                :href    "/api/auth/login-request"

                } "Registrieren / Login"]))

(defn welcome-action-block []
  (let [actual-step @(rf/subscribe [::get-step])]
    [:> Card
     [:> CardContent {:sx {:text-align "center"}}
      [:> Typography {:variant "h2"} "Ich möchte mich für die MALTESER Wallfahrt `ROM 2026` anmelden!"]
      ;[:pre (pr-str @(rf/subscribe [::db/get ::db/me ]))]
      [:br]
      [start-button]
      ]
     ]))